import React from "react";
import LogForm from "./LogForm";
import "./lohstyle.css";
import Image from './logoo1.png'
import { useTranslation } from "react-i18next";

export default function Login() {
  const { t } = useTranslation();
  return (
    <div
      className="d-flex flex-wra"
      style={{
        // width: "71.299rem",
        height: "40.75rem",
        flexShrink: " 0",

        borderRadius: " 0.9375rem 0rem 0rem 0.9375rem",
        background: "#3C4242",
      }}
    >
      <div
        className="logtext d-none d-lg-flex justify-content-center "
        style={{ width: "32.78945rem", height: "40.95rem" }}
      >
        <div
          className="logtext-div"
          style={{ width: "16.825rem", height: "12.355rem" }}
        >
          {/* <img
            className="login-img"
            src="https://s3-alpha-sig.figma.com/img/4ab1/b5a3/b6aa27374a38b52ecdbe48969061ac43?Expires=1698019200&Signature=oaLAzxLEmKelYJbh9M-wu~xUHpSO0kCtE5dQVBt8KzVU9HrxGBD6KMcX2gOnxiYrff5iuSA~5a3AQnOTDMWiWrWMXFn3xj66m4h284aiFnKc~kVKaccuCJ7DVWvGGd0l2gfL0pX~ZpuJ0DfJRvbq9aVDXWvK1rYyH0zIE1ILU4kCFUphDusg7zbntH7SBUq6dvPEKqmpK8cWLlSujkO3sA2iaQlyAjuNLypEedWqS~x~dM1PL9WLG4EZND-yQBs~iaNzxGdP951nrUghwRVnGb0~oJayp2lQo0R0fH6kuP80HasVwEw9NBaq0VSZMhWMyi5vdERwxjj2OiMp9mq-~w__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4"
            
          /> */}
          {/* <img src="https://drive.google.com/file/d/1sRxDqfAKK8DRMpK1xp6a5qFBIwaIGOtb/view?usp=sharing" alt="" /> */}
          <div className="d-flex flex-column justify-content-center align-items-center  ">
            <img src={Image}  width={184} />
            <p className="logtext-p1">{t("welcomeBack")}</p>
            <p className="logtext-p2">{t("takeAMomentToLogIn")}</p>
          </div>
        </div>
      </div>

      <div
        className="d-flex justify-content-center bg-white"
        style={{
          alignItems: "center",
          width: "38.4959rem",
          height: "40.75rem",
        }}
      >
        <LogForm></LogForm>
      </div>
    </div>
  );
}
